import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'gold' | 'navy';
  subtext?: string;
  onClick?: () => void;
};
const variants = {
  gold: 'border-b-4 border-amber-600 bg-amber-400 text-blue-950 shadow-lg shadow-amber-500/30 hover:bg-amber-300 focus:ring-amber-400/50',
  navy: 'border-b-4 border-black/40 bg-blue-950 text-white shadow-lg shadow-blue-950/30 hover:bg-blue-900 focus:ring-blue-950/30'
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  variant = 'gold',
  subtext,
  onClick
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl px-7 py-4 text-center text-base font-black uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus:ring-4 ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-386" data-mp="1jh0c3j426m4k">
      <span data-id="element-387" data-mp="oo3ohufeamf7">{children}</span>
      {subtext && <span className="mt-1 text-xs font-semibold normal-case tracking-normal opacity-80" data-id="element-388" data-mp="om95wmrlj6ea">
          {subtext}
        </span>}
    </motion.a>;
}